/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiStudentsStudentIdEnrollGroupIdDelete$Params {
  studentId: string;
  groupId: string;
}

export function apiStudentsStudentIdEnrollGroupIdDelete(http: HttpClient, rootUrl: string, params: ApiStudentsStudentIdEnrollGroupIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsStudentIdEnrollGroupIdDelete.PATH, 'delete');
  if (params) {
    rb.path('studentId', params.studentId, {});
    rb.path('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiStudentsStudentIdEnrollGroupIdDelete.PATH = '/api/students/{studentId}/enroll/{groupId}';
